import { ChangeEvent, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { LogManager, StringUtil } from "@mcleod/core";
import {
    AutogenLayoutTrimbleVisibilityDataExportControl
} from "./autogen/AutogenLayoutTrimbleVisibilityDataExportControl";

const log = LogManager.getLogger("lme/powerbroker/TrimbleVisibilityDataExportControl");
enum ExportBy { EMAIL = "E", FTP = "F", SFTP = "S" }

export class TrimbleVisibilityDataExportControl extends AutogenLayoutTrimbleVisibilityDataExportControl {

    tableTrimbleVisibilityControlEmailOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const exportBy = this.activeRow?.get("export_by", "F");
        const isFTPorSFTP = ['S', 'F'].includes(exportBy);
        if (tableRow != undefined) {
            const textboxErrorEmail = tableRow.findComponentById("textboxErrorEmail") as Textbox;
            const textboxDateFtpSent = tableRow.findComponentById("textboxDateFtpSent") as Textbox;
            const textboxEmailList = tableRow.findComponentById("textboxEmailList") as Textbox;
            const textboxEmailSent = tableRow.findComponentById("textboxEmailSent") as Textbox;
            textboxErrorEmail.enabled = isFTPorSFTP;
            textboxDateFtpSent.enabled = isFTPorSFTP;
            textboxEmailList.enabled = !isFTPorSFTP;
            textboxEmailSent.enabled = !isFTPorSFTP;
        }
    }

    async postDataSources(): Promise<Boolean> {
        try {
            const activeRow = this.mainDataSource?.activeRow?.data;
            const exportBy = activeRow?.export_by;
            if (ExportBy.EMAIL === exportBy) {
                this.activeRow.set("is_ftp_active", "N");
                this.activeRow.set("is_sftp_active", "N");
            } else if (ExportBy.FTP === exportBy) {
                this.activeRow.set("is_ftp_active", "Y");
                this.activeRow.set("is_sftp_active", "N");
            }
            else if (ExportBy.SFTP === exportBy) {
                this.activeRow.set("is_ftp_active", "Y");
                this.activeRow.set("is_sftp_active", "Y");
            }
            if (!this.mainDataSource?.hasChanged()) {
                return true;
            }
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            log.error(error);
            return false;
        }
    }

    textboxCommunicationExporByOnChange(event: ChangeEvent) {
        const selectedItem = (event.target as Textbox).selectedItem;
        if (selectedItem !== undefined) {
            const isFTPorSFTP = ['S', 'F'].includes(selectedItem.value);
            const setVisibility = (textboxes: Textbox[], visible: boolean) => {
                textboxes.forEach(textbox => { textbox.visible = visible; });
            };
            setVisibility([this.textboxUsername, this.textboxPassword, this.textboxAddress, this.textboxPort, this.textboxFilename, this.textboxRemoteDir, this.textboxRemoteFile], isFTPorSFTP);
            this.textboxUsername.required = isFTPorSFTP;
            this.textboxPassword.required = isFTPorSFTP;
            this.textboxAddress.required = isFTPorSFTP;
            this.switchIsActive.visible = isFTPorSFTP;
            this.textboxCommunicationExporBy.marginLeft = !isFTPorSFTP ? 20 : 0;
            this.textboxFilename.text = StringUtil.isEmptyString(this.textboxFilename.text) ? "tenfour.txt" : this.textboxFilename.text;
            this.textboxRemoteDir.text = StringUtil.isEmptyString(this.textboxRemoteDir.text) ? "/" : this.textboxRemoteDir.text;
            this.textboxAddress.text = StringUtil.isEmptyString(this.textboxAddress.text) ? "integrate.10-4.com" : this.textboxAddress.text;
            this.textboxPort.text = selectedItem.value === ExportBy.FTP ? "21" : selectedItem.value === ExportBy.SFTP ? "22" : this.textboxPort.text;

            const tableRow = this.tableTrimbleVisibilityControlEmail.quickAddRow;
            if (tableRow != undefined) {
                const textboxFTPErrorEmail = tableRow.findComponentById("textboxErrorEmail") as Textbox;
                const textboxDateFtpSent = tableRow.findComponentById("textboxDateFtpSent") as Textbox;
                const textboxEmailList = tableRow.findComponentById("textboxEmailList") as Textbox;
                const textboxEmailSent = tableRow.findComponentById("textboxEmailSent") as Textbox;
                textboxFTPErrorEmail.enabled = isFTPorSFTP;
                textboxEmailList.enabled = !isFTPorSFTP;
                textboxDateFtpSent.enabled = isFTPorSFTP;
                textboxEmailSent.enabled = !isFTPorSFTP;
                textboxEmailList.text = isFTPorSFTP ? '' : textboxEmailList.text;
                textboxFTPErrorEmail.text = isFTPorSFTP ? textboxFTPErrorEmail.text : '';
            }

        }
    }

}
